<template>
	<div class="my-table projectMemberPage">
		<!-- 面包屑组件 -->
		<div class="searchBox flexCenter">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t("projectMembers.txt1")}} </span>
				<span>{{$t("projectMembers.txt2")}} / {{$t("projectMembers.txt3")}} /
					<span class="link">{{detail.projectName}}  {{subNavIndex === 0?$t("projectMembers.txt4"):$t("projectMembers.txt5")}}</span>
				</span>
			</div>
			<div class="flexEnd">
				<div class="handleBoxSeach flexCenter w350">
					<el-input
					:placeholder="$t('projectMembers.txt6')"
					v-model="name" @keypress.native.enter="handleSearch">
					<img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
				</el-input>
				<div class="searchBtn" @click="handleSearch">{{$t('projectMembers.txt7')}}</div>
			</div>
			<div class="searchBtn ml20" @click="returnPage">{{$t('projectMembers.txt8')}}</div>
		</div>
	</div>
	<!-- 面包屑 -->
	<el-card class="tableCard p30">
		<div class="contactTitle">
			<span :class="subNavIndex==index?'activeTitle':''" v-for="(item,index) in settingOption" :key="index" @click="goItemPage(item,index)">{{item.name}}</span>
		</div>
		<div v-if="subNavIndex===0">
			<el-table :data="dataListA">
				<el-table-column label="" type="index" width="50">
				</el-table-column>
				<el-table-column label="">
					<template slot-scope="scope">
						<span>{{scope.row.userName?scope.row.userName+'('+scope.row.realName+')':'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="">
					<template slot-scope="scope">
						<div v-if="isAdmin">
							<span v-if="scope.row.id == detail.owner.id">{{scope.row.id == detail.owner.id?$t('projectMembers.txt9'):scope.row.id == detail.admin.id?$t('projectMembers.txt10'):$t('projectMembers.txt11')}}</span>
							<span v-if="scope.row.id == detail.owner.id && scope.row.id == detail.admin.id">，</span>
							<span v-if="scope.row.id == detail.admin.id">{{scope.row.id == detail.admin.id?$t('projectMembers.txt10'):$t('projectMembers.txt11')}}</span>
							<span v-if="scope.row.id != detail.owner.id && scope.row.id != detail.admin.id">{{$t('projectMembers.txt11')}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column  label="" width="200">
					<template slot-scope="scope">
						<div class="flexStart" v-if="isAdmin">
							<el-button v-if="scope.row.id != detail.admin.id" @click="handleAdministrators(scope.row)" class="handleBtn" type="text">{{$t('projectMembers.txt12')}}</el-button>
							<el-button v-if="scope.row.id != detail.owner.id && scope.row.id != detail.admin.id" @click="handleDeleteUser(scope.row)" class="handleBtn" type="text">{{$t('projectMembers.txt13')}}</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="addPage" v-else>
			<el-table :data="dataListB">
				<el-table-column label="" type="index" width="50">
				</el-table-column>
				<el-table-column label="">
					<template slot-scope="scope">
						<span>{{scope.row.userName?scope.row.userName+'('+scope.row.realName+')':'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column  label="" width="100">
					<template slot-scope="scope">
						<el-button @click="handleAddUser(scope.row)" class="handleBtn" type="text">{{$t('projectMembers.txt14')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<div class="table-footer tablePagination  mt-50" v-show="totalA>0 && subNavIndex===0">
		<el-pagination @size-change="handleSizeChangeA" @current-change="handleCurrentChangeA"
		:current-page="queryInfoA.pageNum" :page-sizes="[10, 20, 30, 40]"
		layout="total, sizes, prev, pager, next" :page-size="queryInfoA.pageSize"
		:total="totalA">
	</el-pagination>
</div>
<div class="table-footer tablePagination  mt-50" v-show="totalB>0 && subNavIndex===1">
	<el-pagination @size-change="handleSizeChangeA" @current-change="handleCurrentChangeB"
	:current-page="queryInfoB.pageNum" :page-sizes="[10, 20, 30, 40]"
	layout="total, sizes, prev, pager, next" :page-size="queryInfoB.pageSize"
	:total="totalB">
</el-pagination>
</div>
</div>
</template>

<script>
	import qs from 'qs';
	export default {
		data() {
			return {
				name:'',
				id: this.$route.query.id,
				detail:{},
				paths: [],
				subNavIndex: 0,
				isAdmin:false,
				settingOption: [],
				dataListA: [],//已加入的成员表格
				dataListB: [],//添加成员表格
				queryInfoA:{
					projectId:this.$route.query.id,
					pageNo:0,
					pageSize:10,
					username:''
				},
				queryInfoB:{
					projectId:this.$route.query.id,
					pageNo:0,
					pageSize:10,
					username:''
				},
				totalA:0,
				totalB:0,
			};
		},
		created() {
			this.loadData();
			this.getDataB();
			this.getDataA();
		},
		computed: {
			currentPath() {
				let { paths } = this;
				if(!paths.length) return '';
				return paths[paths.length - 1].path
			}
		},
		methods: {
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
			goItemPage(item,index){
				this.subNavIndex = index;
				this.picUrl = this.settingOption[index].picUrl;
				if(this.subNavIndex == 1){
					this.getDataA();
				}
			},
			// 数据加载
			async loadData() {
				const {
					data: res
				} = await this.$http.post("/project/detail?id=" + this.id);
				if (!res.success) {
					return this.$message.error(res.message);
				}
				if(res.result.admin.id === localStorage.userId || res.result.owner.id === localStorage.userId) {
					this.isAdmin = true;
					this.settingOption = [{
						name: '已加入的成员'
					},
					{
						name: '添加成员'
					}]
				}else{
					this.isAdmin = false;
					this.settingOption = [{
						name: '已加入的成员'
					}]
				}
				this.detail = res.result;
			},
			handleSearch(){
				if(this.subNavIndex===0){
                  this.queryInfoA.username = this.name;
				  this.getDataA();
				}else{
				this.queryInfoB.username = this.name;
				  this.getDataB();
				}
			},
			// 已加入的成员数据
			async getDataA() {
				const { data: res } = await this.$http.post("/project/projectUsers?" + qs.stringify(this.queryInfoA));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.name = '';
				this.dataListA = res.result.data;
				this.totalA = res.result.total;
			},
			// 项目未加入成员列表
			async getDataB() {
				const { data: res } = await this.$http.post("/project/userList?" + qs.stringify(this.queryInfoB));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.name = '';
				this.dataListB = res.result.data;
				this.totalB = res.result.total;
			},
			// 页面切换
			handleCurrentChangeA(pageNum) {
				this.queryInfoA.pageNo = pageNum;
				this.getDataA();
			},
			handleSizeChangeA(pageSize) {
				this.queryInfoA.pageSize = pageSize;
				this.getDataA();
			},
			// 页面切换
			handleCurrentChangeB(pageNum) {
				this.queryInfoB.pageNo = pageNum;
				this.getDataB();
			},
			handleSizeChangeB(pageSize) {
				this.queryInfoB.pageSize = pageSize;
				this.getDataB();
			},
			// 添加成员
			handleAdd(row){
				console.log(row);
			},
			// 设为管理员
			async handleAdministrators(row){
				let data = {
					userId:row.id,
					id:this.$route.query.id
				}
				const { data: res } = await this.$http.post("/project/setAdmin?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message({
                  message: res.message,
                  type: 'success'
                });
				this.loadData();
			    this.getDataA();
			},
			// 项目添加参与人员
			async handleAddUser(row){
				let data = {
					userId:row.id,
					projectId:this.$route.query.id
				}
				const { data: res } = await this.$http.post("/project/add/user?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message({
                  message: res.message,
                  type: 'success'
                });
				this.loadData();
				this.getDataA();
			    this.getDataB();
			},
			// 项目删除参与人员
			async handleDeleteUser(row){
				let data = {
					userId:row.id,
					projectId:this.$route.query.id
				}
				const { data: res } = await this.$http.post("/project/delete/user?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message({
                  message: res.message,
                  type: 'success'
                });
				this.getDataA();
			    this.getDataB();
			},
		},
	};
</script>

<style lang="less" scoped>
	.projectMemberPage {
		.contactTitle{
			font-size: 30px;
			font-weight: 500;
			color: #AEB0B9;
			margin-bottom: !important;
		}
		.contactTitle span{
			margin-right: 30px;
			cursor: pointer;
		}
		.activeTitle{
			font-size: 30px;
			font-weight: 500;
			color: #222222;
		}
		.flex{
			display: flex;
		}
		.blueTxt{
			color: #1B3B7C;
		}
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}
		/deep/ thead{
			display: none;
		}
	}
	.handleBtn{
		padding: 0;
	}
</style>
